import React from 'react';
import Footer1 from './Footer1/Footer1';
import Footer2 from './Footer2/Footer2';
import styles from "./Footer.module.scss"

const Footer = () => {
    return (
        <>
        <div className={styles.background}>
        <Footer1/> 
        <Footer2/>
        </div>
           
        </>
    )
}

export default Footer
